const getPosthogInstance = () => {
  if (typeof window !== 'undefined' && (window as any).posthog) {
    return (window as any).posthog
  }
  return null
}

export const setPosthogTag = (
  tagName: string,
  tagValue: string | number | boolean
) => {
  const posthog = getPosthogInstance()

  if (posthog) {
    posthog.register({
      [tagName]: tagValue,
    })
  } else {
    console.warn(
      'PostHog instance not found. Make sure PostHog is initialized before calling setPosthogTag.'
    )
  }
}

export const setPosthogTags = (
  tags: Record<string, string | number | boolean>
) => {
  const posthog = getPosthogInstance()

  if (posthog) {
    posthog.register(tags)
  } else {
    console.warn(
      'PostHog instance not found. Make sure PostHog is initialized before calling setPosthogTags.'
    )
  }
}

export const capturePosthogError = (
  error: Error | string,
  properties?: Record<string, any>
) => {
  const posthog = getPosthogInstance()

  if (posthog) {
    posthog.captureException(error, {
      ...properties,
    })
  } else {
    console.warn(
      'PostHog instance not found. Make sure PostHog is initialized before calling capturePosthogError.'
    )
  }
}
